import { useI18n } from '@/hooks/useI18n';
import { Empty } from '@/components/primitives/Empty';

interface AnalyticsEmptyProps {
  title?: string;
  description?: string;
  className?: string;
}

export function AnalyticsEmpty({ title, description, className }: AnalyticsEmptyProps) {
  const { t } = useI18n();
  return (
    <Empty
      title={title ?? t('Aucune donnée disponible', 'No data available')}
      description={
        description ??
        t(
          'Aucune mesure disponible pour cette sélection. Essayez une période plus longue ou une autre identité.',
          'No measurements are available for this selection. Try a longer period or another identity.',
        )
      }
      className={className}
    />
  );
}
